import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { type HTMLAttributes, computed } from 'vue';
import { DropdownMenuCheckboxItem, type DropdownMenuCheckboxItemEmits, type DropdownMenuCheckboxItemProps, DropdownMenuItemIndicator, useForwardPropsEmits } from 'radix-vue';
import { Check } from 'lucide-vue-next';
import { cn } from '@/lib/utils';


export default /*@__PURE__*/_defineComponent({
  __name: 'DropdownMenuCheckboxItem',
  props: {
    checked: { type: [Boolean, String] },
    disabled: { type: Boolean },
    textValue: {},
    asChild: { type: Boolean },
    as: {},
    class: { default: undefined },
    indicatorRight: { type: Boolean, default: false }
  },
  emits: ["select", "update:checked"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emits = __emit;

const delegatedProps = computed(() => {
    const { class: _, indicatorRight: __, ...delegated } = props;

    return delegated;
});

const forwarded = useForwardPropsEmits(delegatedProps, emits);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(DropdownMenuCheckboxItem), _mergeProps(_unref(forwarded), {
    class: 
            _unref(cn)(
                'relative flex cursor-default select-none truncate items-center rounded-md py-2 text-normal outline-none transition-colors focus:bg-gray-100 data-[disabled]:pointer-events-none data-[disabled]:opacity-50',
                props.indicatorRight ? 'pl-3 pr-9' : 'pl-8 pr-3',
                props.class
            )
        
  }), {
    default: _withCtx(() => [
      _createElementVNode("span", {
        class: _normalizeClass(_unref(cn)('absolute flex h-3.5 w-3.5 items-center justify-center', props.indicatorRight ? 'right-2' : 'left-2'))
      }, [
        _createVNode(_unref(DropdownMenuItemIndicator), null, {
          default: _withCtx(() => [
            _createVNode(_unref(Check), { class: "w-4 h-4" })
          ]),
          _: 1
        })
      ], 2),
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 16, ["class"]))
}
}

})